/* Royal Deccan | Stock-safe quantity selectors v3.1
 * Scope: product page + Dawn cart drawer, with live cart.js synchronization.
 * A product-page quantity always displays at least its Shopify min (typically 1).
 * When remaining stock is ZERO, it shows 1 but disables + / Add to Cart / Buy Now.
 * Shopify inventory settings are still the final enforcement at checkout.
 */
(function () {
  'use strict';
  if (window.__rdStockV31) return; // Loaded from both main-product and cart-drawer.
  window.__rdStockV31 = true;

  var quantities = Object.create(null);
  var cartLoaded = false;
  var refreshTimer;
  var uiTimer;
  var lastRequest = 0;
  var cartChangeSeq = 0;
  var dataCache = new WeakMap();

  function number(value, fallback) {
    var n = Number.parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }
  function qtyFor(id) { return Math.max(0, number(quantities[String(id)], 0)); }
  function cartEndpoint() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }
  function buttonState(button, disabled, title) {
    if (!button) return;
    button.disabled = !!disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    if (disabled && title) button.title = title;
    else if (button.title === 'Maximum available stock reached' || button.title === 'Minimum quantity reached') {
      button.removeAttribute('title');
    }
  }
  function queryProductQuantity(root) {
    return root.querySelector('.product-form__quantity input[name="quantity"]');
  }
  function productComponent(script) {
    return script.closest('product-component') || script.closest('product-info');
  }
  function variantMap(script) {
    var original = script.textContent;
    var existing = dataCache.get(script);
    if (existing && existing.text === original) return existing.data;
    try {
      var data = JSON.parse(original);
      dataCache.set(script, { text: original, data: data });
      return data;
    } catch (_) { return {}; }
  }
  function selectedVariant(root) {
    // Shopify's canonical hidden variant input, not a quantity input or form for installments.
    var form = root.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    if (!form) return { form: null, id: null };
    var field = form.querySelector('input[name="id"]');
    return { form: form, id: field && field.value ? String(field.value) : null };
  }
  function validMax(limit, min, step) {
    if (!Number.isFinite(limit)) return Infinity;
    if (limit < min) return min; // Never produce max=0 or max<min on a product page.
    return min + Math.floor((limit - min) / step) * step;
  }
  function updateInputBounds(input, min, cap, step, productPage) {
    // A product selector always stays >= 1; Dawn drawer allows zero to remove an item.
    if (productPage) {
      input.min = String(min);
      input.setAttribute('data-min', String(min));
    }
    var max = validMax(cap, min, step);
    if (Number.isFinite(max)) {
      input.max = String(max);
      input.setAttribute('data-max', String(max));
    } else {
      input.removeAttribute('max');
      input.removeAttribute('data-max');
    }
    var before = number(input.value, min);
    // Restrict manually-entered negatives, zero and quantities beyond real maximum.
    var safe = Math.max(min, before);
    if (Number.isFinite(max)) safe = Math.min(safe, max);
    if (safe !== before || String(before) !== String(input.value)) input.value = String(safe);
    var control = input.closest('quantity-input');
    if (control) {
      var minus = control.querySelector('button[name="minus"]');
      var plus = control.querySelector('button[name="plus"]');
      if (productPage) buttonState(minus, safe <= min, 'Minimum quantity reached');
      buttonState(plus, (Number.isFinite(cap) && cap < min) || (Number.isFinite(max) && safe + step > max), 'Maximum available stock reached');
    }
    return { max: max, value: safe };
  }
  function updateQuantityLabel(wrapper, count) {
    var line = wrapper && wrapper.querySelector('.quantity__rules-cart');
    if (!line) return;
    line.classList.toggle('hidden', count <= 0);
    var inner = line.querySelector('[data-rd-cart-qty-label]');
    if (!inner) return;
    if (!inner.dataset.rdTpl) {
      // Keep Shopify's own localized label; only substitute the displayed count.
      var text = inner.textContent || '';
      inner.dataset.rdTpl = /\d+/.test(text) ? text.replace(/\d+/, '__RD_COUNT__') : '(__RD_COUNT__ in cart)';
    }
    var rendered = inner.dataset.rdTpl.replace('__RD_COUNT__', String(count));
    if (inner.textContent !== rendered) inner.textContent = rendered;
  }
  function markStockUnavailable(button, unavailable) {
    if (!button) return;
    if (unavailable) {
      if (!button.disabled) button.dataset.rdStockDisabled = '1';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    } else if (button.dataset.rdStockDisabled === '1') {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      delete button.dataset.rdStockDisabled;
    }
  }
  function setProductNotice(root, input, unavailable, tracked, cartCount) {
    var slot = input && input.closest('.product-form__quantity');
    if (!slot) return;
    var note = slot.querySelector('[data-rd-stock-notice]');
    if (!note) {
      note = document.createElement('small');
      note.className = 'rd-stock-notice';
      note.setAttribute('data-rd-stock-notice', '');
      note.setAttribute('role', 'status');
      slot.appendChild(note);
    }
    var message = tracked && unavailable ?
      (cartCount > 0 ? 'Maximum available stock is already in your cart.' : 'Currently out of stock.') : '';
    if (note.textContent !== message) note.textContent = message;
    note.hidden = !message;
  }
  function updateProducts() {
    document.querySelectorAll('[data-rd-stock-variants]').forEach(function (script) {
      var root = productComponent(script);
      if (!root) return;
      var field = queryProductQuantity(root);
      var chosen = selectedVariant(root);
      if (!field || !chosen.id) return;
      var variant = variantMap(script)[chosen.id];
      if (!variant) return;
      var minimum = Math.max(1, number(variant.min, 1));
      var step = Math.max(1, number(variant.step, 1));
      var inCart = cartLoaded ? qtyFor(chosen.id) : Math.max(0, number(field.dataset.cartQuantity, 0));
      var stock = variant.stock === null || variant.stock === undefined ? Infinity : Math.max(0, number(variant.stock, 0));
      var rule = variant.ruleMax === null || variant.ruleMax === undefined ? Infinity : Math.max(0, number(variant.ruleMax, 0));
      var available = Math.min(stock, rule) - inCart;
      var blocked = Number.isFinite(available) && available < minimum;
      // Record the actual stock limit independently of the native max. If no stock
      // remains, native min=max=1, and the submit buttons (not the input) are disabled.
      field.dataset.rdRemaining = Number.isFinite(available) ? String(Math.max(0, available)) : '';
      field.dataset.rdMin = String(minimum);
      field.dataset.rdStep = String(step);
      field.setAttribute('data-cart-quantity', String(inCart));
      updateInputBounds(field, minimum, available, step, true);
      if (blocked) {
        field.readOnly = true;
        field.dataset.rdStockReadonly = '1';
      } else if (field.dataset.rdStockReadonly === '1') {
        field.readOnly = false;
        delete field.dataset.rdStockReadonly;
      }
      markStockUnavailable(chosen.form && chosen.form.querySelector('button[type="submit"], button[name="add"]'), blocked);
      markStockUnavailable(root.querySelector('.rd-buy-now'), blocked);
      updateQuantityLabel(field.closest('.product-form__quantity'), inCart);
      setProductNotice(root, field, blocked, Number.isFinite(stock), inCart);
    });
  }
  function updateDrawer() {
    var fields = Array.from(document.querySelectorAll('#CartDrawer input[data-quantity-variant-id]'));
    if (!fields.length) return;
    var totals = Object.create(null);
    fields.forEach(function (field) {
      var id = String(field.dataset.quantityVariantId);
      totals[id] = (totals[id] || 0) + Math.max(0, number(field.value, 0));
    });
    fields.forEach(function (field) {
      var variant = String(field.dataset.quantityVariantId);
      var stock = number(field.dataset.rdStockCap, -1);
      var rule = number(field.dataset.rdVariantRuleMax, -1);
      var total = cartLoaded ? qtyFor(variant) : totals[variant];
      var current = Math.max(0, number(field.value, 0));
      var unused = Infinity;
      if (stock >= 0) unused = Math.max(0, stock - total);
      if (rule >= 0) unused = Math.min(unused, Math.max(0, rule - total));
      // Don't lower an already-present line to below its present value; instead
      // block further increases and let the customer remove/reduce quantities.
      var cap = Number.isFinite(unused) ? current + unused : Infinity;
      var minimum = Math.max(0, number(field.min, 0));
      var step = Math.max(1, number(field.step, 1));
      updateInputBounds(field, minimum, cap, step, false);
    });
  }
  function paint() {
    updateDrawer();
    updateProducts();
  }
  function setCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var counts = Object.create(null);
    cart.items.forEach(function (item) {
      var id = String(item.variant_id || item.id);
      counts[id] = (counts[id] || 0) + Math.max(0, number(item.quantity, 0));
    });
    quantities = counts;
    cartLoaded = true;
    paint();
    return true;
  }
  function refresh() {
    var request = ++lastRequest;
    // If a cart mutation starts while a request is outstanding, ignore the stale
    // response. Any later finished mutation triggers its own refresh.
    var changeAtStart = cartChangeSeq;
    fetch(cartEndpoint(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        if (request !== lastRequest || changeAtStart !== cartChangeSeq) return;
        setCart(cart);
      })
      .catch(function () { paint(); });
  }
  function schedulePaint() {
    clearTimeout(uiTimer);
    uiTimer = setTimeout(paint, 0);
  }
  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay === undefined ? 100 : delay);
  }
  function onMutationSignal() {
    cartChangeSeq++;
    schedulePaint();
    scheduleRefresh(90);
  }
  function isProductField(field) {
    return field && field.matches && field.matches('quantity-input input[name="quantity"]') && !!field.closest('.product-form__quantity');
  }
  function isDrawerField(field) {
    return field && field.matches && field.matches('#CartDrawer quantity-input input[data-quantity-variant-id]');
  }
  function quantityMax(field) {
    var v = field.getAttribute('max');
    return v === null || v === '' ? Infinity : number(v, Infinity);
  }
  function guardEntry(field) {
    var product = isProductField(field);
    var drawer = isDrawerField(field);
    if (!product && !drawer) return;
    var min = product ? Math.max(1, number(field.min, 1)) : Math.max(0, number(field.min, 0));
    var max = quantityMax(field);
    // A product's min must NEVER be zero, including when its remaining stock is zero.
    if (product && max < min) { max = min; field.max = String(min); field.setAttribute('data-max', String(min)); }
    var next = number(field.value, min);
    next = Math.max(min, next);
    if (Number.isFinite(max)) next = Math.min(max, next);
    if (String(next) !== String(field.value)) field.value = String(next);
  }
  // Prevent Dawn/global quantity handlers from moving below 1 on product pages.
  // Deliberately don't disable cart-drawer minus: removing a line is allowed.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
    if (!button) return;
    var parent = button.closest('quantity-input');
    var field = parent && parent.querySelector('input[type="number"]');
    if (!field) return;
    var product = isProductField(field);
    var drawer = isDrawerField(field);
    if (!product && !drawer) return;
    var min = product ? Math.max(1, number(field.min, 1)) : Math.max(0, number(field.min, 0));
    var max = quantityMax(field);
    var step = Math.max(1, number(field.step, 1));
    var current = Math.max(min, number(field.value, min));
    var noStock = product && field.dataset.rdRemaining !== '' && number(field.dataset.rdRemaining, 0) < min;
    if ((button.name === 'minus' && current <= min) ||
        (button.name === 'plus' && (noStock || (Number.isFinite(max) && current + step > max)))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      buttonState(button, true, button.name === 'minus' ? 'Minimum quantity reached' : 'Maximum available stock reached');
      guardEntry(field);
      return;
    }
    schedulePaint(); // Dawn's click handler changes input after capture phase.
  }, true);

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!isProductField(field) && !isDrawerField(field)) return;
    guardEntry(field);
    schedulePaint();
  }, true);
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (isProductField(field) || isDrawerField(field)) {
      guardEntry(field);
      schedulePaint();
      if (isDrawerField(field)) {
        // Dawn publishes cartUpdate when its mutation succeeds; this backup covers
        // custom drawer scripts which don't use the Shopify event bus.
        scheduleRefresh(450);
        setTimeout(function () { scheduleRefresh(60); }, 1000);
      }
    } else if (field && field.closest && (field.closest('product-component') || field.closest('product-info'))) {
      schedulePaint();
      setTimeout(paint, 200); // Async variant HTML changes.
    }
  }, true);

  // No native product submit should send 0, -1 or more than the available quantity.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[id^="product-form-"]:not([id*="installment"])')) return;
    var component = form.closest('product-component') || form.closest('product-info') || document;
    var field = queryProductQuantity(component);
    if (!field) return;
    guardEntry(field);
    var min = Math.max(1, number(field.min, 1));
    var remaining = field.dataset.rdRemaining === '' ? Infinity : number(field.dataset.rdRemaining, 0);
    if (remaining < min || number(field.value, min) > remaining) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedulePaint();
    }
  }, true);
  document.addEventListener('click', function (event) {
    var buy = event.target.closest('.rd-buy-now');
    if (!buy) return;
    var component = buy.closest('product-component') || buy.closest('product-info');
    var field = component && queryProductQuantity(component);
    if (!field) return;
    guardEntry(field);
    var min = Math.max(1, number(field.min, 1));
    var remaining = field.dataset.rdRemaining === '' ? Infinity : number(field.dataset.rdRemaining, 0);
    if (remaining < min || number(field.value, min) > remaining) {
      event.preventDefault();
      event.stopImmediatePropagation();
      schedulePaint();
    }
  }, true);

  // Listen to Dawn's successful cart mutation messages, including REMOVE.
  function subscribeDawn() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          cartChangeSeq++;
          if (!setCart(event && event.cartData)) scheduleRefresh(75);
          // After Dawn finishes its DOM replacement, reconcile the latest state.
          setTimeout(function () { scheduleRefresh(60); }, 220);
        });
      }
    } catch (_) { /* MutationObserver below also supports Dawn cart changes. */ }
  }
  document.addEventListener('cart:updated', onMutationSignal);
  document.addEventListener('cart:refresh', onMutationSignal);
  document.addEventListener('shopify:section:load', function () { onMutationSignal(); });
  window.addEventListener('pageshow', function () { scheduleRefresh(60); });

  // Dawn cart.js and product-form.js replace section HTML after add/remove/quantity.
  var observer = new MutationObserver(function (records) {
    var cartChanged = false;
    var productChanged = false;
    records.forEach(function (record) {
      var target = record.target;
      if (record.type === 'attributes') {
        // Shopify product-info replaces the selected variant input's value.
        if (target && target.matches && target.matches('form[id^="product-form-"] input[name="id"]')) productChanged = true;
        return;
      }
      if (target.nodeType !== 1) return;
      if (target.closest && target.closest('[data-rd-cart-rewards]')) return;
      // Count both removals and additions: deleting the LAST cart line produces
      // zero quantity-input nodes in the replacement HTML.
      if (target.closest && target.closest('cart-drawer')) cartChanged = true;
      if (target.matches && target.matches('cart-drawer')) cartChanged = true;
      if (record.addedNodes.length) {
        Array.from(record.addedNodes).forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('cart-drawer') || (node.querySelector && node.querySelector('cart-drawer'))) cartChanged = true;
          if (node.matches('[data-rd-stock-variants], product-component, product-info, .product-form__quantity') ||
              (node.querySelector && node.querySelector('[data-rd-stock-variants], .product-form__quantity'))) productChanged = true;
        });
      }
    });
    if (productChanged) schedulePaint();
    if (cartChanged) onMutationSignal();
  });
  observer.observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['value']
  });

  var css = document.createElement('style');
  css.textContent = '.rd-stock-notice{display:block;color:#173f35;font-size:12px;margin:6px 0 0}.rd-stock-notice[hidden]{display:none!important}.product-form__quantity quantity-input button:disabled,#CartDrawer quantity-input button[name="plus"]:disabled{opacity:.35;cursor:not-allowed}';
  document.head.appendChild(css);

  function start() { subscribeDawn(); paint(); scheduleRefresh(50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
